import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { ReactComponent as SchedulerIcon } from "./scheduler.svg";

function StartSchedulerMonitoringDialog({ isOpen, onDismiss, onOk }) {
  const { t } = useTranslation();

  return (
    <Dialog
      type="success"
      icon={SchedulerIcon}
      isOpen={isOpen}
      heading={t("scheduler.startMonitoringDialog.heading")}
      text={t("scheduler.startMonitoringDialog.text")}
      buttons={[
        {
          text: t("buttons.notNow"),
          onClick: onDismiss
        },
        {
          text: t("buttons.startMonitoring"),
          onClick: onOk
        }
      ]}
    />
  );
}

export default StartSchedulerMonitoringDialog;
